import React from "react";
import ProductPage from "../../components/ProductPages/ProductPage";
import { PRODUCT_SCREENSHOTS } from "../../components/ProductPages/productScreenshots";

const sections = [
  {
    title: "Side-pot math without a second spreadsheet",
    body: "Prize funds and side pots sit on one payout table. You set the ratios once instead of recalculating each pot by hand when a bowler questions $38.",
  },
  {
    title: "Lock the numbers",
    body: "Lock payouts when they are final. Bowlers see those same amounts on the public prize list.",
  },
  {
    title: "Pay from the locked list",
    body: "See who is owed and what is still to pay. Mark cash paid at the lanes. Print checks from the same locked amounts.",
    to: "/bowling-tournament-check-exports",
    linkLabel: "Check exports",
  },
];

const BowlingTournamentPayouts = () => (
  <ProductPage
    title="Bowling Tournament Payouts | Bowling Tournament App"
    description="Make the money match. Lock prize funds and side pots on one table. Bowlers see the same numbers. Mark cash paid and print checks from that list."
    keywords={[
      "bowling tournament payouts",
      "bowling tournament prize fund",
      "bowling tournament side pots",
      "lock bowling payouts",
    ]}
    canonicalUrl="/bowling-tournament-payouts"
    heading="Make the money match"
    lede="Lock prize funds and side pots on one payout table. Bowlers see the same numbers. Mark cash paid and print checks from that list."
    analyticsLocation="bowling_tournament_payouts"
    secondaryTo="/bowling-payout-calculator"
    secondaryLabel="Payout calculator"
    sectionHeading="From the board to the purse"
    sections={sections}
    screenshot={PRODUCT_SCREENSHOTS.payouts}
  />
);

export default BowlingTournamentPayouts;
